import styled from "@emotion/styled";

import { tokens } from "@/shared/design-system/tokens";

export const Title = styled.h2`
  margin: 0 0 ${tokens.spacing.md};
  color: ${tokens.colors.basics[0]};
  font-size: ${tokens.typography.fontSize.sm};
  font-weight: ${tokens.typography.fontWeight.normal};
`;

export const FormContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Divider = styled.hr`
  width: 100%;
  height: 1px;
  margin: ${tokens.spacing.md} 0;
  border: 0;
  background: ${tokens.colors.basics[700]};
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
`;